<template>
<div
  ref="contextMenu"
  @click.stop
  @contextmenu.stop
  :style="ctxStyle"
  class="ctx-menu-container">
  <div style="background-color:transparent" class="ctx open">
    <ul
      role="menu"
      class="ctx-menu"
      :class="{
        'ctx-menu-right': align ==='right',
        'ctx-menu-left': align ==='left'
      }">
      <li v-for="(menu, i) in menuData" v-show="menu.show" :key="i" :class="{'ctx-item': true, 'has-child': menu.hasChild, 'checked': menu.checked, 'disabled': menu.disabled}" @click="menu.onclick(locals, $event)" @mouseover.capture="e => calcSubMenuPos(e, menu)">
        {{menu.text}}
        <i class="el-icon-caret-right" v-if="menu.hasChild"></i>
        <ul :class="{'ctx-menu': true}" :style="subMenuPos" v-if="menu.hasChild">
          <li v-for="(submenu, i) in menu.children" :class="{'ctx-item': true, checked: submenu.checked}" :key="i" @click="submenu.onclick(locals, $event)" v-show="submenu.show">{{submenu.text}}</li>
        </ul>
      </li>
    </ul>
  </div>
</div>
</template>
<script>
import createBodyClickListener from './body-click-listener'

export default {
  name: 'context-menu',
  props: {
    id: {
      type: String,
      default: 'default-ctx'
    }
  },
  data () {
    return {
      locals: {},
      align: 'left',
      ctxTop: 0,
      ctxLeft: 0,
      subMenuPos: {
        left: '100%',
        top: 0,
        right: 0,
        bottom: 0
      },
      visible: false
    }
  },
  created () {
    // 参数是监听到body click时要做的事情
    // 监听自身之外的元素的事件
    this.bodyClickListener = createBodyClickListener(
      (e) => {
        let isOpen = !!this.visible
        let outsideClick = isOpen && !this.$el.contains(e.target)
        // 如果是在自身之外点击
        if (outsideClick) {
          if (e.which !== 1) {
            // 不是左键点击
            e.preventDefault()
            e.stopPropagation()
            return false
          } else {
            // 左键点击
            this.visible = false
            this.$emit('ctx-cancel', this.locals)
            // e.stopPropagation()
          }
        } else {
          this.visible = false
          this.$emit('ctx-close', this.locals)
        }
      }
    )
  },
  methods: {

    /*
     * this function handles some cross-browser compat issues
     * thanks to https://github.com/callmenick/Custom-Context-Menu
     */
    setPositionFromEvent (e) {
      e = e || window.event

      const scrollingElement = document.scrollingElement || document.documentElement

      if (e.pageX || e.pageY) {
        this.ctxLeft = e.pageX
        this.ctxTop = e.pageY - scrollingElement.scrollTop
      } else if (e.clientX || e.clientY) {
        this.ctxLeft = e.clientX + scrollingElement.scrollLeft
        this.ctxTop = e.clientY + scrollingElement.scrollTop
      }

      this.$nextTick(() => {
        const menu = this.$el
        const minHeight = (menu.style.minHeight || menu.style.height).replace('px', '') || 32
        const minWidth = (menu.style.minWidth || menu.style.width).replace('px', '') || 32
        const scrollHeight = menu.scrollHeight || minHeight
        const scrollWidth = menu.scrollWidth || minWidth
        const largestHeight = window.innerHeight - scrollHeight - 25
        const largestWidth = window.innerWidth - scrollWidth - 25

        if (this.ctxTop > largestHeight) this.ctxTop = largestHeight
        if (this.ctxLeft > largestWidth) this.ctxLeft = largestWidth
      })
      return e
    },
    calcSubMenuPos (e, menu) {
      if (!menu.hasChild) {
        return
      }
      let subMenuEl = e.target.querySelector('ul')
      if (!subMenuEl) {
        return
      }
      let subMenuWidth = subMenuEl.offsetWidth
      let subMenuHeight = subMenuEl.offsetHeight
      let firstMenuWidth = this.$el.scrollWidth
      let totalWidth = subMenuWidth + firstMenuWidth
      this.$nextTick(() => {
        const rightSpace = window.innerWidth - totalWidth - this.$el.getBoundingClientRect().left
        if (rightSpace < 25) {
          this.subMenuPos.left = 'auto'
          this.subMenuPos.right = '100%'
        } else {
          this.subMenuPos.left = '100%'
          this.subMenuPos.right = 'auto'
        }
        const bottomSpace = window.innerHeight - subMenuHeight - e.target.getBoundingClientRect().top
        if (bottomSpace < 25) {
          this.subMenuPos.top = 'auto'
          this.subMenuPos.bottom = '0'
        } else {
          this.subMenuPos.top = '0'
          this.subMenuPos.bottom = 'auto'
        }
      })
    },

    open (targetData, e) {
      this.visible = true
      this.$emit('ctx-open', this.locals = targetData)
      this.setPositionFromEvent(e)
      this.$el.setAttribute('tab-index', -1)
      this.bodyClickListener.start()
      return this
    }
  },
  watch: {
    visible (newVal) {
      if (!newVal) {
        this.bodyClickListener.stop()
        this.$el.parentNode.removeChild(this.$el)
        this.$destroy()
      }
    }
  },
  computed: {
    ctxStyle () {
      return {
        'display': this.visible ? 'block' : 'none',
        'top': (this.ctxTop || 0) + 'px',
        'left': (this.ctxLeft || 0) + 'px'
      }
    },
    menuData () {
      let a = this.data.map(item => ({
        ...item,
        hasChild: item.children && !!item.children.length,
        show: 'show' in item ? item.show : true,
        onclick: item.onclick || (() => {}),
        children: (item.children || []).map(item => ({
          ...item,
          show: 'show' in item ? item.show : true,
          onclick: item.onclick || (() => {}),
        })),
      }))
      console.log(a)
      return a
    }
  }
}
</script>
<style src="./index.css">
  
</style>




// WEBPACK FOOTER //
// main.vue?1995a723